export default __webpack_public_path__ + "static/media/bg-wave.033ec7bb.svg";